var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-splash',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v(_vm._s(_vm.__("All offers are updated"))+"!")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }